import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "interactivepdfexportpreference"
    }}>{`InteractivePDFExportPreference`}</h1>
    <p>{`Interactive PDF export settings for the application object.`}</p>
    <h2 {...{
      "id": "instance"
    }}>{`Instance`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`isValid`}</strong>{` `}</p>
      <p parentName="blockquote">{`Returns true if the object specifier resolves to valid objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Application `}<strong parentName="p">{`parent`}</strong>{` `}</p>
      <p parentName="blockquote">{`The parent of the InteractivePDFExportPreference (a Application).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Events `}<strong parentName="p">{`events`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of events.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`EventListeners `}<strong parentName="p">{`eventListeners`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of event listeners.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`PdfDisplayTitleOptions `}<strong parentName="p">{`pdfDisplayTitle`}</strong>{` `}</p>
      <p parentName="blockquote">{`The export PDF display title.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`defaultDocumentLanguage`}</strong>{` `}</p>
      <p parentName="blockquote">{`Sets the default document language in the exported PDF. The correct ISO code of the language must be provided.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`exportAsSinglePages`}</strong>{` `}</p>
      <p parentName="blockquote">{`Export each page or spread as a separate PDF file.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`singlePagesPDFSuffix`}</strong>{` `}</p>
      <p parentName="blockquote">{`Suffix to be used at the end of each file when pages are exported as separate PDF files.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`pageRange`}</strong>{` `}</p>
      <p parentName="blockquote">{`The pages to print, specified either as an enumeration or a string. To specify a range, separate page numbers in the string with a hyphen (-). To specify separate pages, separate page numbers in the string with a comma (,). Can return: PageRange enumerator or String.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`exportReaderSpreads`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, each spread in the exported document is combined into a single page that has spread's original width.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`viewPDF`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, automatically opens the PDF file after exporting.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`generateThumbnails`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, generates thumbnail images for each page or spread.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`exportLayers`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, saves each layer as an Acrobat layer within the PDF document.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`includeStructure`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, creates a tagged PDF file. Note: If acrobat compatibility is acrobat 6 or higher, tags are visible only when the PDF is opened in Acrobat 6 or higher.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`PdfMagnificationOptions `}<strong parentName="p">{`pdfMagnification`}</strong>{` `}</p>
      <p parentName="blockquote">{`The export PDF magnification options.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`PageLayoutOptions `}<strong parentName="p">{`pdfPageLayout`}</strong>{` `}</p>
      <p parentName="blockquote">{`The export PDF page layout.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`openInFullScreen`}</strong>{` `}</p>
      <p parentName="blockquote">{`Open PDF in full screen mode.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`flipPages`}</strong>{` `}</p>
      <p parentName="blockquote">{`Automatically flip pages in the exported PDF.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`flipPagesSpeed`}</strong>{` `}</p>
      <p parentName="blockquote">{`The speed that the pages flip.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`PageTransitionOverrideOptions `}<strong parentName="p">{`pageTransitionOverride`}</strong>{` `}</p>
      <p parentName="blockquote">{`The name of the page transition to use for all pages.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`InteractivePDFInteractiveElementsOptions `}<strong parentName="p">{`interactivePDFInteractiveElementsOption`}</strong>{` `}</p>
      <p parentName="blockquote">{`How to draw interactive elements.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`PDFRasterCompressionOptions `}<strong parentName="p">{`pdfRasterCompression`}</strong>{` `}</p>
      <p parentName="blockquote">{`The PDF raster compression options.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`PDFJPEGQualityOptions `}<strong parentName="p">{`pdfJPEGQuality`}</strong>{` `}</p>
      <p parentName="blockquote">{`The PDF JPEG quality options.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`rasterResolution`}</strong>{` `}</p>
      <p parentName="blockquote">{`The raster resolution. Can return: RasterResolutionOptions enumerator or Long Integer (72 - 300).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`usePDFStructureForTabOrder`}</strong>{` `}</p>
      <p parentName="blockquote">{`Use tagged PDF structure for interactive elements tab order.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`properties`}</strong>{` `}</p>
      <p parentName="blockquote">{`A property that allows setting of several properties at the same time.`}</p>
    </blockquote>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <blockquote>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSource`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Generates a string which, if executed, will return the InteractivePDFExportPreference.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`InteractivePDFExportPreference `}<strong parentName="p">{`getElements`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Resolves the object specifier, creating an array of object references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSpecifier`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Retrieves the object specifier.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EventListener `}<strong parentName="p">{`addEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Adds an event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`removeEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Removes the event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-1"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      